import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteCompanyVehicleTypeActions as Actions,
  DeleteCompanyVehicleTypeRequestAction as RequestAction,
} from 'store/ducks/companyVehicleTypes';

export function* deleteCompanyVehicleTypeRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `company-vehicle-types/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Regra desvinculada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
